import { useTranslation } from "react-i18next";
import { ProgressBar, Text } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";
import {
	COVER_PROGRESS_TRACK_COLOR,
	COVER_TEXT_COLOR,
} from "../AnimatedHeaderScreen/constants";
import Box from "../Box";

type Props = {
	label?: string;
	percent: number;
	invertColors?: boolean;
};

export const LessonDetailProgress = ({
	label,
	percent,
	invertColors,
}: Props) => {
	const theme = useAppTheme();
	const { t } = useTranslation();
	const clampedPercent = Math.min(Math.max(percent, 0), 100);
	const textColor = invertColors ? COVER_TEXT_COLOR : theme.colors.onSurface;

	return (
		<Box gap={8}>
			<Box
				flexDirection="row"
				alignItems="center"
				justifyContent="space-between"
				gap={12}
			>
				<Text variant="labelLarge" style={{ color: textColor }}>
					{label ?? t("lessons.detail.progress.label")}
				</Text>
				<Text variant="labelLarge" style={{ color: textColor }}>
					{`${Math.round(clampedPercent)}%`}
				</Text>
			</Box>
			<ProgressBar
				progress={clampedPercent / 100}
				color={invertColors ? COVER_TEXT_COLOR : theme.colors.primary}
				style={{
					backgroundColor: invertColors
						? COVER_PROGRESS_TRACK_COLOR
						: theme.colors.secondaryContainer,
					borderRadius: theme.roundness * 100,
				}}
			/>
		</Box>
	);
};
